<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialog"
      >
        <v-card class="no__padding">
          <v-card-title class="pt-0 pl-0">
            <h2 v-if="editMode">Upravit slevu</h2>
            <h2 v-else>Přidat slevu</h2>
          </v-card-title>
          <v-card-text class="text-xs-center pt-0 px-0">
            <v-form lazy-validation ref="createForm" v-model="valid">
              <v-layout row wrap>
                <v-flex xs12>
                  <meny v-model="updateItem.mena_id" @changed="(e) => { updateItem.mena = e; }" :disabled="editMode"></meny>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm12>
                  <productsearch label="Vyhledat produkt" v-model="updateItem.produkt_id" @changed="(e) => { updateItem.produkt = e; }" class="mx-2" :disabled="editMode"></productsearch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="mx-2">
                    <v-layout row wrap row>
                      <v-flex d-flex class="pt-3 mt-1">
                        Odečíst
                      </v-flex>
                      <v-flex xs3 d-flex class="mx-1">
                        <v-text-field
                          type="number"
                          v-model="updateItem.kredity"
                          suffix="kr."
                        ></v-text-field>
                      </v-flex>
                      <v-flex d-flex class="text-xs-center pl-3 pt-3 mt-1">
                        na
                      </v-flex>
                      <v-flex xs3 d-flex class="mx-1">
                        <v-text-field
                          type="number"
                          v-model="updateItem.kredity_slevy_mj"
                          :suffix="updateItem.mena != null ? updateItem.mena.zkratka : ''"

                        ></v-text-field>
                      </v-flex>
                      <v-flex d-flex class="pt-3 mt-1 pl-3">
                        slevy
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <h3 class="text-xs-left mx-2">Množstevní rozmezí</h3>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-for="(item, i) in updateItem.slevy" :key="'sleva-'+i.toString()">
                <v-flex xs12 sm3>
                  <v-text-field
                    label="Od"
                    class="mx-2"
                    :min="0"
                    :suffix="'ks'"
                    type="number"
                    v-model="item.mnozstvi_od"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    label="Do"
                    class="mx-2"
                    :min="0"
                    :suffix="'ks'"
                    type="number"
                    v-model="item.mnozstvi_do"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                    label="Sleva"
                    class="mx-2"
                    :min="0"
                    :suffix="(updateItem.mena != null ? updateItem.mena.zkratka : '') + '/ks'"
                    type="number"
                    v-model="item.max_sleva"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-btn color="red" dark small flat depressed fab @click="updateItem.slevy.splice(updateItem.slevy.indexOf(item), 1)"><v-icon small>delete</v-icon></v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap :class="{'justify-center':$vuetify.breakpoint.xs}">
                <v-btn color="primary" @click="addRow" flat icon small>
                  <v-icon>add</v-icon>
                </v-btn>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending" v-if="!editMode">Přidat</v-btn>
            <v-btn color="blue darken-3 elevation-0" dark @click="edit" :loading="sending" v-else>Upravit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialog=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogRemove"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Smazání slevy</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            Opravu chcete smazat slevu na produkt <strong>{{ removeItem.produkt.nazev }}</strong>?
          </v-card-text>
          <v-divider class="mt-2 mb-2"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red elevation-0" dark @click="remove" :loading="removing"><v-icon class="mr-2">delete</v-icon>Smazat</v-btn>
            <v-btn color="grey elevation-0 lighten-3" @click="dialogRemove=false" v-if="!removing">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12 sm9>
                <h3>Pravidla slev na jednorázové nákupy</h3>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-left text-md-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat slevu
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.mena.nazev }}</td>
                  <td>{{ props.item.produkt.nazev }}</td>
                  <td>Odečíst <strong>{{ props.item.kredity }}</strong> kreditů na <strong>{{ props.item.kredity_slevy_mj | formatMoney }} {{ props.item.mena.zkratka }}</strong> slevy</td>
                  <td>
                    <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-2 pr-2">
                      <v-card-text class="pa-2 pl-0 pr-0">
                        <div v-for="(s, i) in props.item.slevy" class="{'mt-1': i == 0}" :key="'sleva-' + i.toString()">
                          <h3 class="mt-1 mb-1 pa-0 ml-0 mr-0 pl-0 pr-0">{{s.mnozstvi_od}} - {{s.mnozstvi_do}}: sleva {{s.max_sleva | formatMoney}} {{ props.item.mena.zkratka }}</h3>
                        </div>
                      </v-card-text>
                    </v-card>
                  </td>
                  <td class="text-xs-right">
                    <v-btn color="primary" class="elevation-0 ma-0" @click="editClick(props.item)">
                      <v-icon small class="mr-2">edit</v-icon> Upravit
                    </v-btn>
                    <v-btn color="red" class="elevation-0 ma-0" @click="removeClick(props.item)" flat>
                      <v-icon small class="mr-2">delete</v-icon> Smazat
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      dialog: false,
      editMode: false,
      dialogDetail: false,
      loading: false,
      sending: false,
      headers: [
        { text: 'Měna', value: 'mena', sortable: false },
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false },
        { text: 'Odečtení kreditů', value: 'pocet_odecitanych_kreditu', sortable: false },
        { text: 'Slevy dle množství', value: 'sleva_dle_mnozstvi', sortable: false },
        { text: '', value: null, sortable: false, align: 'right' }
      ],
      headersBezSlevy: [
        { text: 'Produkt', value: 'cilovy_produkt' }
      ],
      items: [],
      updateItem: null,
      dialogInit: { mena_id: null, mena: null, produkt_id: null, produkt: null, kredity: null, kredity_slevy_mj: null, slevy: [ { id: null, mnozstvi_od: null, mnozstvi_do: null, max_sleva: null }] },
      sending: false,
      valid: true,
      dialogRemove: false,
      removing: false,
      removeItem: null
    };
  },
  mounted () {
    this.load();
  },
  methods: {
    load (f) {
      window.API.get("produkty/slevy-jednorazove-nakupy").then(function(body) {
        this.items = body;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    addRow () {
      this.updateItem.slevy.push({
        id: null,
        mnozstvi_od: null,
        mnozstvi_do: null,
        max_sleva: null
      });
    },
    createClick () {
      this.updateItem = window.th.copy(this.dialogInit);
      this.editMode = false;
      this.dialog = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("produkty/slevy-jednorazove-nakupy", this.updateItem).then(function(body) {
          if (body.inserted) {
            this.load(() => {
              this.dialog = false;
              this.sending = false;
            });
          }
          else
            this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    editClick (v) {
      this.updateItem = window.th.copy(v);
      this.editMode = true;
      this.dialog = true;
    },
    edit () {
      this.sending = true;
      window.API.put("produkty/slevy-jednorazove-nakupy/" + this.updateItem.id, {
        kredity: this.updateItem.kredity,
        kredity_slevy_mj: this.updateItem.kredity_slevy_mj,
        slevy: this.updateItem.slevy
      }).then(function(body) {
        if (body.updated) {
          this.load(() => {
            this.dialog = false;
            this.sending = false;
          });
        }
        else
          this.sending = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    },
    removeClick(v) {
      this.removeItem = v;
      this.dialogRemove = true;
    },
    remove () {
      this.removing = true;
      window.API.delete("produkty/slevy-jednorazove-nakupy/" + this.removeItem.id).then(function(body) {
        if (body.deleted) {
          this.load(() => {
            this.dialogRemove = false;
            this.removing = false;
          });
        }
        else
          this.removing = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.removing = false;
      }.bind(this));
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Slevy/SlevyJednorazoveNakupy.vue